import type { FC } from "react";

import { Separator } from "@jti/core-components/components/Separator";

import type { ShippingMethodCodeFieldConfig } from "@checkout-v2/formFields";

export type BasicContactDetailsSeparatorProps = {
  shippingMethodCode: ShippingMethodCodeFieldConfig;
};

export const BasicContactDetailsSeparator: FC<BasicContactDetailsSeparatorProps> = ({ shippingMethodCode }) => {
  const hasNoShippingOptions = shippingMethodCode.options.length === 0;
  const hasSingleAtHomeOption =
    shippingMethodCode.options.length === 1 && shippingMethodCode.options[0].type === "atHome";

  if (hasNoShippingOptions || hasSingleAtHomeOption) {
    return null;
  }

  return <Separator />;
};
